// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"0b4e1c63","732":"d194e837","977":"aa85b640"}[chunkId] + ".chunk.js";
};